export default "__VITE_ASSET__DxRixY2i__"